import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from '../shared/AnimatedSection';
const GOLD = '#C9A84C';
const GOLD_LIGHT = '#E8D48B';
/**
 * Final emotional CTA section — sits just before the Disclaimer.
 * Leaves the user with the core psychological question of LOS 12
 * and a clear path back to the selector.
 */
export function TuReinoYaExiste() {
  const scrollToGrid = () => {
    document.getElementById('sign-grid')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative py-24 md:py-32 px-4 md:px-6 overflow-hidden bg-cosmic-black" data-id="element-438">
      {/* Radial glow */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-439">
        <div className="absolute inset-0" style={{
        background: 'radial-gradient(ellipse at 50% 50%, rgba(201,168,76,0.12) 0%, transparent 65%)'
      }} data-id="element-440" />
      </div>

      {/* Twelve-fold mandala backdrop */}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center opacity-[0.07]" data-id="element-441">
        <motion.svg width="720" height="720" viewBox="0 0 720 720" fill="none" animate={{
        rotate: 360
      }} transition={{
        duration: 260,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-442">
          <circle cx="360" cy="360" r="320" stroke={GOLD} strokeWidth="0.6" data-id="element-443" />
          <circle cx="360" cy="360" r="220" stroke={GOLD} strokeWidth="0.5" data-id="element-444" />
          <circle cx="360" cy="360" r="120" stroke={GOLD} strokeWidth="0.5" data-id="element-445" />
          {Array.from({
          length: 12
        }).map((_, i) => <line key={i} x1="360" y1="40" x2="360" y2="680" stroke={GOLD} strokeWidth="0.4" transform={`rotate(${i * 30} 360 360)`} data-id="element-446" />)}
        </motion.svg>
      </div>

      {/* Embers */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-447">
        {[...Array(12)].map((_, i) => <motion.div key={i} className="absolute w-[2px] h-[2px] rounded-full" style={{
        backgroundColor: GOLD,
        left: `${i * 8.5 % 100}%`,
        top: `${i * 13 % 100}%`,
        boxShadow: `0 0 6px ${GOLD}`
      }} animate={{
        y: [-12, -40, -12],
        opacity: [0.15, 0.55, 0.15]
      }} transition={{
        duration: 7 + i % 5,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: i * 0.5
      }} data-id="element-448" />)}
      </div>

      <div className="relative z-10 container mx-auto max-w-3xl text-center" data-id="element-449">
        <AnimatedSection data-id="element-450">
          <motion.div className="inline-flex items-center gap-3 mb-8" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} data-id="element-451">
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-gold-primary" data-id="element-452" />
            <span className="text-[11px] tracking-[0.4em] uppercase font-serif text-gold-light" data-id="element-453">
              La Decisión
            </span>
            <div className="h-px w-12 bg-gradient-to-r from-gold-primary to-transparent" data-id="element-454" />
          </motion.div>

          <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-8 md:mb-10 leading-tight px-2" style={{
          textShadow: `0 0 35px rgba(201,168,76,0.4)`
        }} data-id="element-455">
            Tu Reino ya existe{' '}
            <span style={{
            color: GOLD_LIGHT
          }} data-id="element-456">
              dentro de ti.
            </span>
          </h2>
        </AnimatedSection>

        <AnimatedSection delay={0.2} data-id="element-457">
          <div className="space-y-5 md:space-y-6 text-lg md:text-xl leading-relaxed text-gray-200 font-serif px-2 mb-12 md:mb-14" data-id="element-458">
            <p data-id="element-459">La pregunta no es si tienes un Reino.</p>
            <p className="text-gold-light/95 italic" data-id="element-460">
              La pregunta es: ¿qué parte de ti ha estado tomando decisiones en
              silencio toda tu vida?
            </p>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.4} data-id="element-461">
          <motion.button onClick={scrollToGrid} className="w-full sm:w-auto inline-block px-12 md:px-14 py-5 md:py-6 font-bold rounded-xl text-base md:text-lg tracking-[0.18em]" style={{
          backgroundColor: GOLD,
          color: '#050508',
          boxShadow: '0 0 45px rgba(201,168,76,0.55), 0 0 80px rgba(201,168,76,0.25)'
        }} whileHover={{
          scale: 1.04,
          boxShadow: '0 0 75px rgba(201,168,76,0.9), 0 0 110px rgba(201,168,76,0.45)'
        }} whileTap={{
          scale: 0.96
        }} animate={{
          boxShadow: ['0 0 40px rgba(201,168,76,0.5), 0 0 75px rgba(201,168,76,0.2)', '0 0 60px rgba(201,168,76,0.75), 0 0 105px rgba(201,168,76,0.35)', '0 0 40px rgba(201,168,76,0.5), 0 0 75px rgba(201,168,76,0.2)']
        }} transition={{
          boxShadow: {
            duration: 3.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} data-id="element-462">
            ENTRAR A LOS 12
          </motion.button>
        </AnimatedSection>
      </div>
    </section>;
}